import { Quote } from "../types";

export const CURATED_QUOTES: Quote[] = [
  {
    "id": "quote-1",
    "category": "STILLNESS",
    "body": {
      "en": "Silence is not the <em class='serif-italic text-white'>absence</em> of sound, but the <em class='serif-italic text-white'>presence</em> of ultimate clarity.",
      "ru": "Тишина — это не <em class='serif-italic text-white'>отсутствие</em> звука, а <em class='serif-italic text-white'>присутствие</em> абсолютной ясности.",
      "uk": "Тиша — це не <em class='serif-italic text-white'>відсутність</em> звуку, а <em class='serif-italic text-white'>присутність</em> абсолютної ясності.",
      "pl": "Cisza to nie <em class='serif-italic text-white'>brak</em> dźwięku, ale <em class='serif-italic text-white'>obecność</em> absolutnej przejrzystości.",
      "es": "El silencio no es la <em class='serif-italic text-white'>ausencia</em> de sonido, sino la <em class='serif-italic text-white'>presencia</em> de una claridad absoluta.",
      "de": "Stille ist nicht die <em class='serif-italic text-white'>Abwesenheit</em> von Geräuschen, sondern die <em class='serif-italic text-white'>Gegenwart</em> absoluter Klarheit.",
      "fr": "Le silence n'est pas l'<em class='serif-italic text-white'>absence</em> de son, mais la <em class='serif-italic text-white'>présence</em> d'une clarté absolue.",
      "it": "Il silenzio non è l'<em class='serif-italic text-white'>assenza</em> di suono, ma la <em class='serif-italic text-white'>presenza</em> di una chiarezza assoluta.",
      "pt": "O silêncio não é a <em class='serif-italic text-white'>ausência</em> de som, mas a <em class='serif-italic text-white'>presença</em> de clareza absoluta.",
      "tr": "Sessizlik sesin <em class='serif-italic text-white'>yokluğu</em> değil, mutlak berraklığın <em class='serif-italic text-white'>varlığıdır</em>.",
      "zh": "寂静不是声音的<em class='serif-italic text-white'>缺失</em>，而是极致清晰的<em class='serif-italic text-white'>临在</em>。",
      "ja": "静寂とは音の<em class='serif-italic text-white'>不在</em>ではなく、究極の明晰さの<em class='serif-italic text-white'>発露</em>である。",
      "ko": "침묵은 소리의 <em class='serif-italic text-white'>부재</em>가 아니라, 명확함의 <em class='serif-italic text-white'>존재</em>입니다.",
      "ar": "الصمت ليس <em class='serif-italic text-white'>غياب</em> الصوت، بل هو <em class='serif-italic text-white'>حضور</em> الوضوح المطلق.",
      "hi": "मौन ध्वनि की <em class='serif-italic text-white'>অনुपस्थिति</em> नहीं, बल्कि परम स्पष्टता की <em class='serif-italic text-white'>उपस्थिति</em> है।",
      "nl": "Stilte is niet de <em class='serif-italic text-white'>afwezigheid</em> van geluid, maar de <em class='serif-italic text-white'>aanwezigheid</em> van ultieme helderheid.",
      "sv": "Tystnad är inte <em class='serif-italic text-white'>frånvaron</em> av ljud, utan <em class='serif-italic text-white'>närvaron</em> av absolut klarhet.",
      "no": "Stillhet er ikke <em class='serif-italic text-white'>fraværet</em> av lyd, men <em class='serif-italic text-white'>nærværet</em> av absolut klarhet.",
      "da": "Stilhed er ikke <em class='serif-italic text-white'>fraværet</em> af lyd, men <em class='serif-italic text-white'>tilstedeværelsen</em> af absolut klarhed.",
      "fi": "Hiljaisuus ei ole äänen <em class='serif-italic text-white'>puuttumista</em>, vaan täydellisen selkeyden <em class='serif-italic text-white'>läsnäoloa</em>."
    },
    "author": {
      "en": "Zen Proverb",
      "ru": "Дзенская пословица",
      "uk": "Дзенське прислів'я",
      "pl": "Przysłowie Zen",
      "es": "Proverbio Zen",
      "de": "Zen-Sprichwort",
      "fr": "Proverbe Zen",
      "it": "Proverbio Zen",
      "pt": "Provérbio Zen",
      "tr": "Zen Atasözü",
      "zh": "禅宗谚语",
      "ja": "禅の格言",
      "ko": "젠 속담",
      "ar": "حكمة زن",
      "hi": "ज़ेन कहावत",
      "nl": "Zen Spreekwoord",
      "sv": "Zen-ordspråk",
      "no": "Zen-ordspråk",
      "da": "Zen-ordsprog",
      "fi": "Zen-sanonta"
    }
  },
  {
    "id": "quote-2",
    "category": "MOUNT",
    "body": {
      "en": "In the midst of chaos, <em class='serif-italic text-white'>stillness</em> resides as your inner absolute sanctuary.",
      "ru": "Среди хаоса <em class='serif-italic text-white'>спокойствие</em> остается вашим внутренним абсолютным убежищем.",
      "uk": "Серед хаосу <em class='serif-italic text-white'>спокій</em> залишається вашим внутрішнім абсолютним притулком.",
      "pl": "W środku chaosu <em class='serif-italic text-white'>spokój</em> pozostaje Twoją wewnętrzną absolutną ostoją.",
      "es": "En medio del caos, la <em class='serif-italic text-white'>calma</em> permanece como tu santuario interior absoluto.",
      "de": "Inmitten des Chaos bleibt die <em class='serif-italic text-white'>Stille</em> Ihr inneres absolutes Heiligtum.",
      "fr": "Au milieu du chaos, le <em class='serif-italic text-white'>calme</em> demeure votre sanctuaire intérieur absolu.",
      "it": "In mezzo al caos, la <em class='serif-italic text-white'>Calma</em> rimane il tuo santuario interiore.",
      "pt": "No meio do caos, a <em class='serif-italic text-white'>calma</em> permanece como seu santuário interior absoluto.",
      "tr": "Kaosun ortasında <em class='serif-italic text-white'>sakinlik</em> içsel mutlak sığınağınızdır.",
      "zh": "在混沌之中，<em class='serif-italic text-white'>宁静</em>是你内心的绝对避风港。",
      "ja": "混沌の只中で、<em class='serif-italic text-white'>静寂</em>こそがあなたの絶対的な内なる聖域となる。",
      "ko": "혼돈 한가운데에서 <em class='serif-italic text-white'>고요함</em>은 당신의 절대적인 안식처로 남습니다.",
      "ar": "في وسط الفوضى، يظل <em class='serif-italic text-white'>الهدوء</em> ملاذك الداخلي المطلق.",
      "hi": "अराजकता के बीच, <em class='serif-italic text-white'>शांति</em> आपका आंतरिक परम आश्रय बनी रहती है।",
      "nl": "In het midden van chaos blijft <em class='serif-italic text-white'>rust</em> je innerlijke absolute toevluchtsoord.",
      "sv": "I mitten av kaos förblir <em class='serif-italic text-white'>lugnet</em> din inre absoluta fristad.",
      "no": "I midten av kaos forblir <em class='serif-italic text-white'>roen</em> ditt indre absolutte fristed.",
      "da": "I midten af kaos forbliver <em class='serif-italic text-white'>roen</em> dit indre absolutte fristed.",
      "fi": "Kaaoksen keskellä <em class='serif-italic text-white'>tyyneys</em> pysyy sisäisenä turvapaikkanasi."
    },
    "author": {
      "en": "Classic Philosopher",
      "ru": "Классическая философия",
      "uk": "Класична філософія",
      "pl": "Filozofia Klasyczna",
      "es": "Filosofía Clásica",
      "de": "Klassische Philosophie",
      "fr": "Philosophie Classique",
      "it": "Filosofia Classica",
      "pt": "Filosofia Clássica",
      "tr": "Klasik Felsefe",
      "zh": "古典哲学",
      "ja": "古典哲学",
      "ko": "고전 철학",
      "ar": "الفلسفة الكلاسيكية",
      "hi": "शास्त्रीय दर्शन",
      "nl": "Klassieke Filosofie",
      "sv": "Klassisk filosofi",
      "no": "Klassisk filosofi",
      "da": "Klassisk filosofi",
      "fi": "Klassinen filosofia"
    }
  },
  {
    "id": "quote-3",
    "category": "FLOW",
    "body": {
      "en": "The river moves <em class='serif-italic text-white'>swiftly</em>, yet the moon's reflection remains completely <em class='serif-italic text-white'>unmoved</em>.",
      "ru": "Река течет <em class='serif-italic text-white'>стремительно</em>, но отражение луны остается абсолютно <em class='serif-italic text-white'>неподвижным</em>.",
      "uk": "Річка тече <em class='serif-italic text-white'>стрімко</em>, але відбиток місяця залишається абсолютно <em class='serif-italic text-white'>непорушним</em>.",
      "pl": "Rzeka płynie <em class='serif-italic text-white'>bystro</em>, lecz odbicie księżyca pozostaje całkowicie <em class='serif-italic text-white'>nieruchome</em>.",
      "es": "El río fluye <em class='serif-italic text-white'>rápidamente</em>, pero el reflejo de la luna permanece <em class='serif-italic text-white'>Inmóvil</em>.",
      "de": "Der Fluss fließt <em class='serif-italic text-white'>rasch</em>, doch die Spiegelung des Mondes bleibt völlig <em class='serif-italic text-white'>unbewegt</em>.",
      "fr": "La rivière coule <em class='serif-italic text-white'>rapidement</em>, mais le reflet de la lune reste totalement <em class='serif-italic text-white'>immobile</em>.",
      "it": "Il fiume scorre <em class='serif-italic text-white'>rapidamente</em>, ma il riflesso della luna rimane completamente <em class='serif-italic text-white'>immobile</em>.",
      "pt": "O rio corre <em class='serif-italic text-white'>rapidamente</em>, mas o reflexo da lua permanece totalmente <em class='serif-italic text-white'>imóvel</em>.",
      "tr": "Nehir <em class='serif-italic text-white'>hızla</em> akar, ancak ayın yansıması tamamen <em class='serif-italic text-white'>hareketsiz</em> kalır.",
      "zh": "江水<em class='serif-italic text-white'>奔流不息</em>，而水中明月的倒影却<em class='serif-italic text-white'>纹丝不动</em>。",
      "ja": "川は<em class='serif-italic text-white'>速やかに</em>流れるが、月に映る影は完全に<em class='serif-italic text-white'>微動だにしない</em>。",
      "ko": "강물은 <em class='serif-italic text-white'>빠르게</em> 흘러가지만, 달의 그림자는 완벽하게 <em class='serif-italic text-white'>고요함</em>을 유지합니다.",
      "ar": "النهر يجري <em class='serif-italic text-white'>بسرعة</em>، لكن انعكاس القمر يظل <em class='serif-italic text-white'>ثابتاً</em> تماماً.",
      "hi": "नदी <em class='serif-italic text-white'>तेजी से</em> बहती है, फिर भी चंद्रमा का प्रतिबिंब पूरी तरह <em class='serif-italic text-white'>अचल</em> रहता है।",
      "nl": "De rivier stroomt <em class='serif-italic text-white'>snel</em>, maar de weerspiegeling van de maan blijft volkomen <em class='serif-italic text-white'>onbeweeglijk</em>.",
      "sv": "Floden flödar <em class='serif-italic text-white'>snabbt</em>, men månens reflektion förblir helt <em class='serif-italic text-white'>orörlig</em>.",
      "no": "Elven renner <em class='serif-italic text-white'>raskt</em>, men månens refleksjon forblir helt <em class='serif-italic text-white'>urørlig</em>.",
      "da": "Floden strømmer <em class='serif-italic text-white'>hurtigt</em>, men månens refleksion forbliver helt <em class='serif-italic text-white'>ubevægelig</em>.",
      "fi": "Joki virtaa <em class='serif-italic text-white'>nopeasti</em>, mutta kuun heijastus pysyy täysin <em class='serif-italic text-white'>liikkumattomana</em>."
    },
    "author": {
      "en": "Zen Koan",
      "ru": "Дзенский коан",
      "uk": "Дзенський коан",
      "pl": "Kōan Zen",
      "es": "Koan Zen",
      "de": "Zen-Koan",
      "fr": "Koan Zen",
      "it": "Koan Zen",
      "pt": "Koan Zen",
      "tr": "Zen Koanı",
      "zh": "禅宗公案",
      "ja": "禅の公案",
      "ko": "선 공안",
      "ar": "كوان زن",
      "hi": "ज़ेन कोआन",
      "nl": "Zen Koan",
      "sv": "Zen-koan",
      "no": "Zen-koan",
      "da": "Zen-koan",
      "fi": "Zen-koan"
    }
  },
  {
    "id": "quote-4",
    "category": "PRESENCE",
    "body": {
      "en": "Observe the space <em class='serif-italic text-white'>between</em> passing thoughts; there lies the doorway to <em class='serif-italic text-white'>infinite</em> focus.",
      "ru": "Наблюдайте пространство <em class='serif-italic text-white'>между</em> мыслями; там открывается дверь к <em class='serif-italic text-white'>бесконечной</em> фокусировке.",
      "uk": "Спостерігайте простір <em class='serif-italic text-white'>між</em> думками; там двері до <em class='serif-italic text-white'>нескінченного</em> фокусу.",
      "pl": "Obserwuj przestrzeń <em class='serif-italic text-white'>między</em> myślami; tam leżą drzwi do <em class='serif-italic text-white'>nieskończonego</em> skupienia.",
      "es": "Observa el espacio <em class='serif-italic text-white'>entre</em> los pensamientos; allí está la puerta a la concentración <em class='serif-italic text-white'>Infinita</em>.",
      "de": "Beobachten Sie den Raum <em class='serif-italic text-white'>zwischen</em> den Gedanken; dort liegt das Tor zu <em class='serif-italic text-white'>unendlichem</em> Fokus.",
      "fr": "Observez l'espace <em class='serif-italic text-white'>entre</em> les pensées ; là se trouve la porte d'un focus <em class='serif-italic text-white'>infini</em>.",
      "it": "Osserva lo spazio <em class='serif-italic text-white'>tra</em> i pensieri; lì si trova la porta della concentrazione <em class='serif-italic text-white'>infinita</em>.",
      "pt": "Observe o espaço <em class='serif-italic text-white'>entre</em> os pensamentos; ali está a porta para o foco <em class='serif-italic text-white'>infinito</em>.",
      "tr": "Düşüncelerin <em class='serif-italic text-white'>arasındaki</em> boşluğu gözlemleyin; <em class='serif-italic text-white'>sonsuz</em> odaklanmanın kapısı oradadır.",
      "zh": "观察思维<em class='serif-italic text-white'>缝隙之间</em>的停顿；那是通往<em class='serif-italic text-white'>无限</em>专注的大门。",
      "ja": "思考と思考の<em class='serif-italic text-white'>隙間</em>を観察せよ。<em class='serif-italic text-white'>無限</em>の集中への扉がそこにある。",
      "ko": "생각과 생각 <em class='serif-italic text-white'>사이</em>의 공간을 관찰하세요. 거기에 <em class='serif-italic text-white'>무한한</em> 몰입으로 통하는 문이 있습니다.",
      "ar": "راقب المساحة <em class='serif-italic text-white'>بين</em> الأفكار العابرة؛ هناك تكمن بوابة التركيز <em class='serif-italic text-white'>اللافيائي</em>.",
      "hi": "विचारों के <em class='serif-italic text-white'>बीच</em> के स्थान का निरीक्षण करें; वहां <em class='serif-italic text-white'>अनंत</em> एकाग्रता का द्वार निहित है।",
      "nl": "Observeer de ruimte <em class='serif-italic text-white'>tussen</em> gedachten; daar ligt de deur naar <em class='serif-italic text-white'>oneindige</em> focus.",
      "sv": "Observera utrymmet <em class='serif-italic text-white'>mellan</em> tankar; där ligger dörren till <em class='serif-italic text-white'>oändlig</em> fokus.",
      "no": "Observer rommet <em class='serif-italic text-white'>mellom</em> tankene; der ligger døren til <em class='serif-italic text-white'>uendelig</em> fokus.",
      "da": "Observer rummet <em class='serif-italic text-white'>mellem</em> tankerne; der ligger døren til <em class='serif-italic text-white'>uendelig</em> fokus.",
      "fi": "Havainnoi ajatusten <em class='serif-italic text-white'>välistä</em> tilaa; siellä on ovi <em class='serif-italic text-white'>äärettömään</em> keskittymiseen."
    },
    "author": {
      "en": "Mindful Text",
      "ru": "Осознанный текст",
      "uk": "Усвідомлений текст",
      "pl": "Tekst Uważności",
      "es": "Texto de Atención Plena",
      "de": "Achtsamkeitstext",
      "fr": "Texte de Pleine Conscience",
      "it": "Testo di Consapevolezza",
      "pt": "Texto de Atenção Plena",
      "tr": "Farkındalık Metni",
      "zh": "正念格言",
      "ja": "マインドフルネスの言葉",
      "ko": "마음챙김 문구",
      "ar": "نص التأمل",
      "hi": "माइंडफुलनेस पाठ",
      "nl": "Mindfulness Tekst",
      "sv": "Mindfulness-text",
      "no": "Mindfulness-tekst",
      "da": "Mindfulness-tekst",
      "fi": "Tietoisuusteksti"
    }
  },
  {
    "id": "quote-5",
    "category": "RETREAT",
    "body": {
      "en": "To understand the world, one must sometimes <em class='serif-italic text-white'>turn away</em> from it completely and embrace <em class='serif-italic text-white'>nothingness</em>.",
      "ru": "Чтобы понять мир, нужно иногда <em class='serif-italic text-white'>отстраниться</em> от него и принять <em class='serif-italic text-white'>тишину</em>.",
      "uk": "Щоб зрозуміти світ, потрібно іноді <em class='serif-italic text-white'>відсторонитися</em> від нього та прийняти <em class='serif-italic text-white'>тишу</em>.",
      "pl": "Aby zrozumieć świat, trzeba czasem <em class='serif-italic text-white'>odsunąć się</em> od niego i przyjąć <em class='serif-italic text-white'>ciszę</em>.",
      "es": "Para entender el mundo, a veces hay que <em class='serif-italic text-white'>alejarse</em> por completo y abrazar la <em class='serif-italic text-white'>nada</em>.",
      "de": "Um die Welt zu verstehen, muss man sich manchmal völlig von ihr <em class='serif-italic text-white'>abwenden</em> und das <em class='serif-italic text-white'>Nichts</em> umarmen.",
      "fr": "Pour comprendre le monde, il faut parfois s'en <em class='serif-italic text-white'>éloigner</em> complètement et embrasser le <em class='serif-italic text-white'>silence</em>.",
      "it": "Per capire il mondo, a volte bisogna <em class='serif-italic text-white'>allontanarsi</em> completamente e abbracciare il <em class='serif-italic text-white'>nulla</em>.",
      "pt": "Para entender o mundo, às vezes é preciso <em class='serif-italic text-white'>afastar-se</em> completamente e abraçar o <em class='serif-italic text-white'>nada</em>.",
      "tr": "Dünyayı anlamak için bazen ondan tamamen <em class='serif-italic text-white'>uzaklaşmak</em> ve <em class='serif-italic text-white'>hiçliği</em> kucaklamak gerekir.",
      "zh": "要理解这个世界，有时必须彻底<em class='serif-italic text-white'>转过身去</em>，拥抱<em class='serif-italic text-white'>虚无</em>。",
      "ja": "世界を理解するには、時に世界から完全に<em class='serif-italic text-white'>離れ</em>、<em class='serif-italic text-white'>無</em>を受け入れなければならない。",
      "ko": "세상을 이해하려면 때로는 세상으로부터 완전히 <em class='serif-italic text-white'>돌아서서</em> <em class='serif-italic text-white'>공(空)</em>을 받아들여야 합니다.",
      "ar": "لفهم العالم، يجب على المرء أحياناً أن <em class='serif-italic text-white'>يبتعد</em> عنه تماماً ويعانق <em class='serif-italic text-white'>العدم</em>.",
      "hi": "दुनिया को समझने के लिए, कभी-कभी इससे पूरी तरह <em class='serif-italic text-white'>दूर</em> होना पड़ता है और <em class='serif-italic text-white'>शून्यता</em> को अपनाना पड़ता है।",
      "nl": "Om de wereld te begrijpen, moet men zich er soms volledig van <em class='serif-italic text-white'>afwenden</em> en de <em class='serif-italic text-white'>leegte</em> omarmen.",
      "sv": "För att förstå världen måste man ibland <em class='serif-italic text-white'>vända sig bort</em> helt och omfamna <em class='serif-italic text-white'>ingenting</em>.",
      "no": "For å forstå verden må man noen ganger <em class='serif-italic text-white'>vende seg bort</em> helt og omfavne <em class='serif-italic text-white'>ingenting</em>.",
      "da": "For at forstå verden må man nogle gange <em class='serif-italic text-white'>vende sig bort</em> helt og omfavne <em class='serif-italic text-white'>intetheden</em>.",
      "fi": "Ymmärtääkseen maailmaa on joskus <em class='serif-italic text-white'>käännyttävä pois</em> ja syleiltävä <em class='serif-italic text-white'>tyhjyyttä</em>."
    },
    "author": {
      "en": "Sufi Saying",
      "ru": "Суфийская мудрость",
      "uk": "Суфійська мудрість",
      "pl": "Mądrość Sufi",
      "es": "Sabiduría Sufí",
      "de": "Sufi-Weisheit",
      "fr": "Sagesse Soufie",
      "it": "Saggezza Sufi",
      "pt": "Sabedoria Sufi",
      "tr": "Sufi Sözü",
      "zh": "苏菲智慧",
      "ja": "スーフィーの教え",
      "ko": "수피 명언",
      "ar": "حكمة صوفية",
      "hi": "सूफ़ी कहावत",
      "nl": "Sofi Wijsheid",
      "sv": "Sufisk visdom",
      "no": "Sufi-visdom",
      "da": "Sufi-visdom",
      "fi": "Sufilainen viisaus"
    }
  },
  {
    "id": "quote-6",
    "category": "ORIGIN",
    "body": {
      "en": "Form is <em class='serif-italic text-white'>emptiness</em>, emptiness is <em class='serif-italic text-white'>form</em>. All resides inside the glass container of time.",
      "ru": "Форма есть <em class='serif-italic text-white'>пустота</em>, пустота есть <em class='serif-italic text-white'>форма</em>. Все находится в стеклянном сосуде времени.",
      "uk": "Форма є <em class='serif-italic text-white'>порожнеча</em>, порожнеча є <em class='serif-italic text-white'>форма</em>. Все знаходиться у скляній посудині часу.",
      "pl": "Forma jest <em class='serif-italic text-white'>pustką</em>, pustka jest <em class='serif-italic text-white'>formą</em>. Wszystko mieści się w szklanym naczyniu czasu.",
      "es": "La forma es <em class='serif-italic text-white'>vacío</em>, el vacío es <em class='serif-italic text-white'>forma</em>. Todo reside dentro del recipiente de cristal del tiempo.",
      "de": "Form ist <em class='serif-italic text-white'>Leere</em>, Leere ist <em class='serif-italic text-white'>Form</em>. Alles ruht im gläsernen Gefäß der Zeit.",
      "fr": "La forme est <em class='serif-italic text-white'>vide</em>, le vide est <em class='serif-italic text-white'>forme</em>. Tout réside dans le récipient en verre du temps.",
      "it": "La forma è <em class='serif-italic text-white'>vuoto</em>, il vuoto è <em class='serif-italic text-white'>forma</em>. Tutto risiede nel recipiente di vetro del tempo.",
      "pt": "A forma é <em class='serif-italic text-white'>vazio</em>, o vazio é <em class='serif-italic text-white'>forma</em>. Tudo reside no recipiente de vidro do tempo.",
      "tr": "Form <em class='serif-italic text-white'>boşluktur</em>, boşluk <em class='serif-italic text-white'>formdur</em>. Her şey zamanın cam fanusunun içindedir.",
      "zh": "色即是<em class='serif-italic text-white'>空</em>，空即是<em class='serif-italic text-white'>色</em>。万物皆栖于时间的琉璃容器之中。",
      "ja": "色即是<em class='serif-italic text-white'>空</em>、空即是<em class='serif-italic text-white'>色</em>。すべては時間のガラス容器の中に収まる。",
      "ko": "색즉시<em class='serif-italic text-white'>공</em>, 공즉시<em class='serif-italic text-white'>색</em>. 모든 것은 시간이라는 유리 용기 안에 존재합니다.",
      "ar": "الشكل هو <em class='serif-italic text-white'>الفراغ</em>، والفراغ هو <em class='serif-italic text-white'>الشكل</em>. كل شيء يستقر داخل وعاء الوقت الزجاجي.",
      "hi": "रूप ही <em class='serif-italic text-white'>शून्यता</em> है, शून्यता ही <em class='serif-italic text-white'>रूप</em> है। सब कुछ समय के कांच के पात्र में निवास करता है।",
      "nl": "Vorm is <em class='serif-italic text-white'>leegte</em>, leegte is <em class='serif-italic text-white'>vorm</em>. Alles rust in het glazen vat van de tijd.",
      "sv": "Form är <em class='serif-italic text-white'>tomhet</em>, tomhet är <em class='serif-italic text-white'>form</em>. Allt vilar i tidens glasbehållare.",
      "no": "Form er <em class='serif-italic text-white'>tomhet</em>, tomhet er <em class='serif-italic text-white'>form</em>. Alt hviler i tidens glassbeholder.",
      "da": "Form er <em class='serif-italic text-white'>tomhed</em>, tomhed er <em class='serif-italic text-white'>form</em>. Alt hviler i tidens glasbeholder.",
      "fi": "Muoto on <em class='serif-italic text-white'>tyhjyyttä</em>, tyhjyys on <em class='serif-italic text-white'>muotoa</em>. Kaikki lepää ajan lasisäiliössä."
    },
    "author": {
      "en": "Heart Sutra",
      "ru": "Сутра Сердца",
      "uk": "Сутра Серця",
      "pl": "Sutra Serca",
      "es": "Sutra del Corazón",
      "de": "Herz-Sutra",
      "fr": "Sūtra du Cœur",
      "it": "Sutra del Cuore",
      "pt": "Sutra do Coração",
      "tr": "Kalp Sutrası",
      "zh": "心经",
      "ja": "般若心経",
      "ko": "반야심경",
      "ar": "سوترا القلب",
      "hi": "हृदय सूत्र",
      "nl": "Hart Sutra",
      "sv": "Hjärtsutran",
      "no": "Hjertesutraen",
      "da": "Hjertesutraen",
      "fi": "Sydänsutra"
    }
  }
];
